module.exports = __webpack_public_path__ + "static/img/logo.c90a87e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header/logo.png
// module id = xYTw
// module chunks = 12